export default "/images/6fecc8c5fa1f984208d8d1edefc15155.avif";